import React from "react";
import Jibber from "/app/src/jibber";
import { connect } from "react-redux";
import { Flex } from "/app/src/component";

import ItemEditorView from "./ItemEditorView";
import QuickResponseModel from "/app/src/model/QuickResponse/model";
import ItemNormalView from "./ItemNormalView";

class Item extends Jibber {
  constructor(props) {
    super(props);

    this.useState({
      screen: "normal",
    });

    this.saveToDB = this.saveToDB.bind(this);
    this.deleteFromDB = this.deleteFromDB.bind(this);
  }

  saveToDB(title, body) {
    this.props.dispatch(QuickResponseModel.update(this.props.id, title, body));
    this.setState({ screen: "normal" });
  }
  deleteFromDB() {
    this.props.dispatch(QuickResponseModel.delete(this.props.id));
  }

  render() {
    const { title, body } = this.props;
    if (this.props.searchInput) {
      let searchInput = this.props.searchInput.toLowerCase();
      if (
        !this.props.title.toLowerCase().includes(searchInput) &&
        !this.props.body.toLowerCase().includes(searchInput)
      ) {
        return null;
      }
    }
    let item = null;
    switch (this.state.screen) {
      case "edit":
        return (item = (
          <ItemEditorView
            title={title}
            body={body}
            toNormal={() => {
              this.setScreen("normal");
            }}
            saveToDB={this.saveToDB}
          />
        ));
      case "normal":
      default:
        item = (
          <ItemNormalView
            title={title}
            body={body}
            toEditor={() => {
              this.setScreen("edit");
            }}
            deleteFromDB={this.deleteFromDB}
          />
        );
    }

    return (
      <Flex
        margin="16px"
        borderRadius="20px"
        overflow="hidden"
        position="relative"
      >
        {item}
      </Flex>
    );
  }
}

export default connect()(Item);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/Item/Item.js